<template>
  <div class="min-h-screen flex">
    <div class="flex flex-col sm:max-w-sm w-full flex-shrink-0 border-r" :class="{'hidden sm:flex': open}">
      <div class="w-full px-6 h-20 border-b">
        <div class="max-w-7xl h-full w-full flex justify-center items-center mx-auto">
          <h4 class="text-yank">Profile Settings</h4>
        </div>
      </div>
      <div class="flex-1">
        <nav>
          <div class="pl-6 hover:bg-platinumMild" :class="{'sm:bg-platinumHot sm:hover:bg-platinumHot': page == 'details'}">
            <inertia-link class="flex items-center justify-between pr-5 text-sm font-medium text-yank relative py-4 leading-1 border-b border-platinumFire" :href="$route('profile-settings.show', 'details')">
              Profile Details
              <ChevronRight class="h-5 w-5 text-payneFire" />
            </inertia-link>
          </div>

          <div class="pl-6 sm:hover:bg-platinumMild" :class="{'sm:bg-platinumHot sm:hover:bg-platinumHot': page == 'password'}">
            <inertia-link class="flex items-center justify-between pr-5 text-sm font-medium text-yank relative py-4 leading-1 border-b border-platinumFire" :href="$route('profile-settings.show', 'password')">
              Password
              <ChevronRight class="h-5 w-5 text-payneFire" />
            </inertia-link>
          </div>

          <div class="hidden pl-6 sm:hover:bg-platinumMild" :class="{'sm:bg-platinumHot sm:hover:bg-platinumHot': page == 'notifications'}">
            <inertia-link class="flex items-center justify-between pr-5 text-sm font-medium text-yank relative py-4 leading-1 border-b border-platinumFire" :href="$route('profile-settings.show', 'notifications')">
              Notifications
              <ChevronRight class="h-5 w-5 text-payneFire" />
            </inertia-link>
          </div>
        </nav>
      </div>
    </div>
    <template v-if="open">
      <ProfileDetailsSettings v-if="page == 'details'" @close="open = false" />
      <PasswordSettings v-if="page == 'password'" @close="open = false" />
      <NotificationSettings v-if="page == 'notifications'" @close="open = false" />
    </template>
  </div>
</template>

<script>
  import AppLayout from '@/layout/app-layout'
  import ChevronRight from '@/components/svg/ChevronRight'
  import ProfileDetailsSettings from '@/components/settings/ProfileDetailsSettings'
  import PasswordSettings from '@/components/settings/PasswordSettings'
  import NotificationSettings from '@/components/settings/NotificationSettings'

  export default {
    name: 'Settings',

    layout: AppLayout,

    components: {
      ChevronRight,
      ProfileDetailsSettings,
      PasswordSettings,
      NotificationSettings,
    },

    props: {
      page: String,
      flash: Object,
    },

    data() {
      return {
        open: true,
      }
    },

    watch: {
      flash: {
        handler(flash) {
          if (flash.success && flash.success !== '') {
            this.$toast.success(flash.success);
          }
          if (flash.error && flash.error !== '') {
           this.$toast.error(flash.error);
          }
        },
        deep: true,
      }
    },
  }
</script>
